import { Button } from "web-design-system";

export function LinkExpired() {
  return (
    <div className="h-dvh w-dvw">
      <div className="flex flex-col size-full gap-4 items-center justify-center">
        <h1>🚨 Link Expired</h1>
        <p className="text-center text-muted-foreground">
          The link you are trying to access has expired. Please contact the
          distributor for a new link.
        </p>
        <Button onClick={() => window.location.reload()} size="lg">
          Reload
        </Button>
      </div>
    </div>
  );
}
